/**
 * @file history对象
 * @author mengchen <sisimengchen@gmail.com>
 */
import { createBrowserHistory, createHashHistory } from 'history';

export const historyMode = 'browserHistory'; // process.env.TARGET === 'githubpages' ? 'hashHistory' : 'browserHistory';

const createHistory =
  historyMode == 'hashHistory' ? createHashHistory : createBrowserHistory;

export const history = createHistory({
  getUserConfirmation: (message, callback) => callback(true),
  forceRefresh: false
});

export let unlisten = history.listen((location, action) => {
  console.log(
    `The current URL is ${location.pathname}${location.search}${location.hash}`
  );
  console.log(`The last navigation action was ${action}`);
});

export let unblock = history.block((location, action) => '测试文案');

// const onPageChange = function (location) {
//   location = location || window.location;
//   if (window.bbtMonitor && window.bbtMonitor.config) {
//     let pageName = '';
//     const pathname = location.pathname;
//     pathname.replace(/(\/h5_fe_article\/html\/)([\s\S]*)(\/)([\s\S]*)/, function (
//       match,
//       p1,
//       p2
//     ) {
//       pageName = p2;
//       return match;
//     });
//     pageName &&
//       window.bbtMonitor.config({
//         pageName
//       });
//   }
// };
